exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.styles--onlyXs__35dAD{display:none !important}}@media (min-width: 768px){.styles--smUp__H-Q6m{display:none !important}}@media (max-width: 999px){.styles--mdDown__3J9Jk{display:none !important}}@media (max-width: 767px){.styles--Paper__2q3aB{border-radius:0 !important}.styles--head__t9LXZ{border-radius:0 !important}.styles--Sticky__GOdor{border-radius:0 !important}}.styles--lowPadding__S2NtP{padding:12px !important}\n", ""]);

// exports
exports.locals = {
	"onlyXs": "styles--onlyXs__35dAD",
	"smUp": "styles--smUp__H-Q6m",
	"mdDown": "styles--mdDown__3J9Jk",
	"Paper": "styles--Paper__2q3aB",
	"paper": "styles--Paper__2q3aB",
	"head": "styles--head__t9LXZ",
	"Sticky": "styles--Sticky__GOdor",
	"sticky": "styles--Sticky__GOdor",
	"lowPadding": "styles--lowPadding__S2NtP"
};